























































































import { Component, Vue } from 'vue-property-decorator';
import LinkGoalsViewModel
  from '@/vue-app/view-models/allianz-dashboard/goals/link-goals-view-model';

@Component({
  name: 'LinkGoalsCard',
  components: {
    GoalsUndefinedCard: () => import('@/vue-app/components/allianz-dashboard/goals/GoalsUndefinedCard.vue'),
    FlagshipProfilingCard: () => import('@/vue-app/components/my-investment-dashboard-v2/FlagshipProfilingCard.vue'),
    FlagshipLinkGoalsWizardWealth: () => import('@/vue-app/components/flagship/flagship-link-goals/FlagshipLinkGoalsWizardWealth.vue'),
    DistributeBalanceUnallocatedModal: () => import('@/vue-app/components/goals-dashboard/unallocated-balance/DistributeBalanceUnallocatedModal.vue'),
    LoadingDataCard: () => import('@/vue-app/components/home-dashboard/LoadingDataCard.vue'),
    StepSuccessWealth: () => import('@/vue-app/components/flagship/flagship-link-goals/steps-wealth/StepSuccessWealth.vue'),
  },
})
export default class GoalsUndefinedCard extends Vue {
  link_goals_view_model = Vue.observable(new LinkGoalsViewModel());

  async created() {
    await this.link_goals_view_model.initialize();
  }
}
